import React from 'react';
import { Space } from 'antd';
import { useSelector } from 'react-redux';
import { toLogout } from '@/common/utils';
import ComponentLog from '@/components/component-log';

function UserInfo() {
  const userInfo = useSelector((state) => state.userInfo);

  return (
    <ComponentLog>
      <div className="nav-user-info" clstag="yx_center|top navigation_erp">
        <Space size={10} align="center">
          <img src={userInfo?.userMap.headImg} className="user-info-img" />
          <Space direction="vertical" size={0}>
            <span className="erp-name " style={{}}>
              {userInfo?.userMap.erp}
            </span>
            <a onClick={toLogout}>退出登录</a>
          </Space>
        </Space>
      </div>
    </ComponentLog>
  );
}

export default UserInfo;
